import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { isFuture, isPast, isToday } from "date-fns";
import { useTranslation } from "react-i18next";
import { getDateToReadableText } from "@utils/DateUtils";
import StatusMessageBanner from "@components/StatusMessageBanner/StatusMessageBanner";
import { mapAirportIataToName } from "@mappings";
import { currentIataStatusWidgets, forecastCurrentIataStatusWidgets, historicIataStatusWidgets, } from "@widgets/registry";
import { useDatePickerContext } from "@contexts/DatePickerContext";
import { useIataContext } from "@contexts/IataContext";
import PageLayout from "./PageLayout/PageLayout";
const MainPage = () => {
    const { picker: { id, from }, } = useDatePickerContext();
    const { iata: airport } = useIataContext();
    const { t, i18n } = useTranslation();
    const handleWidgetsByDate = () => {
        if (isPast(from) && !isToday(from)) {
            return historicIataStatusWidgets;
        }
        else if (isToday(from)) {
            return currentIataStatusWidgets;
        }
        else if (isFuture(from)) {
            return forecastCurrentIataStatusWidgets;
        }
        else {
            return currentIataStatusWidgets;
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { style: { marginTop: "1rem" }, children: _jsx(StatusMessageBanner, {}) }), _jsx(PageLayout, { customDatePickerProps: {
                    id,
                }, title: `${t("pages.main.statusAt")} ${mapAirportIataToName(airport)} ${getDateToReadableText(i18n.language).toLowerCase()}`, widgets: handleWidgetsByDate() })] }));
};
export default MainPage;
